//import axios from 'axios'
import {
    removeToken,
    getToken
} from './auth'
import {
    Base64
} from 'js-base64'
import {
    get
} from 'lodash'

const service = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_DEV_BASE_API : process.env.VUE_APP_BASE_API,
    withCredentials: true,
    timeout: 5000,
    headers: {
        'Content-Type': 'application/json'
    },
})

service.interceptors.request.use((config) => {
    // 增加 认证头信息
    try {
        config.headers.Authorization = 'Bearer ' + Base64.decode(getToken().toString())
    } catch (error) {
        config.headers.Authorization = ''
    }
    return config
}, (error) => {
    // 错误是根据状态码 做相应的操作
    return Promise.reject(error)
})

service.interceptors.response.use((response) => {
    return response.data
}, (error) => {
    const status = get(error, 'response.status')
    switch (status) {
        case 400:
            error.message = '请求错误'
            break
        case 401:
            removeToken()
            //window.location.reload();
            error.message = '未授权，请登录'
            break
        case 403:
            error.message = '拒绝访问'
            break
        case 404:
            error.message = `请求地址出错: ${error.response.config.url}`
            break
        case 408:
            error.message = '请求超时'
            break
        case 500:
            error.message = '服务器内部错误'
            break
        case 501:
            error.message = '服务未实现'
            break
        case 502:
            error.message = '网关错误'
            break
        case 503:
            error.message = '服务不可用'
            break
        case 504:
            error.message = '网关超时'
            break
        case 505:
            error.message = 'HTTP版本不受支持'
            break
        default:
            error.message = '其他异常信息：' + status
            break
    }
    //Message.error(error.message)
    return Promise.reject(error)
})

export default service